
import {
  defineComponent,
  useFetch,
  computed,
  useStore,
  onBeforeMount
} from "@nuxtjs/composition-api";

import VBreadcrumb from "~/components/VBreadcrumb.vue";

import StockCalendar from "~/components/cruise-calendar/stock-calendar.vue";
import StockCalendarHeader from "~/components/cruise-calendar/stock-calendar-header.vue";
import StockCalendarCell from "~/components/cruise-calendar/stock-calendar-cell.vue";
import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue";
import FilterItem from "~/components/cruise-calendar/filter-item.vue";
import SortList from "~/components/cruise-calendar/sort-list.vue";
import ProductList from "~/components/cruise-calendar/product-list.vue";
import AppDock from '~/components/layouts/AppDock.vue'

import {
  useCruiseCalendarFilter,
  useCruiseCalendarCruiseList,
  useCruiseCalendarDateList,
} from "~/composables/cruise-calendar";
import {dayjs, get, isEqual} from "~/utils/helpers";
import {toValue, watchDebounced, watchPausable} from "@vueuse/core";

export default defineComponent({
  auth: false,
  layout: "Main",
  components: {
    VBreadcrumb,
    StockCalendar,
    StockCalendarHeader,
    StockCalendarCell,
    PlatformAdvertStairSwiper,
    FilterItem,
    SortList,
    // VPagination,
    ProductList,
    AppDock
  },
  head: {
    title: "邮轮日历",
  },
  setup() {
    const store = useStore();

    const breadcrumbs = [{to: "/", label: "首页"}, {label: "邮轮日历"}];

    /******************* 筛选器数据 *******************/
    const {
      state: filterData,
      execute: fetchFilter,
      months,
      cities,
      routes,
      cruiseRouteFirst,
      cruiseRouteSecondary,
      city,
      travel,
      checkedFirstRoute,
    } = useCruiseCalendarFilter();

    /******************* 日历数据 *******************/
    const {
      state: dateData,
      execute: fetchDateList,
      getDateStockData,
      date,
      onPickDate
    } = useCruiseCalendarDateList(
      () => ({
        route: toValue(cruiseRouteSecondary),
        cruise_route_first: toValue(cruiseRouteFirst),
        city: toValue(city),
        travel: toValue(travel),
      }),
      {
        isDistributor: () => store.getters.isDistributor as boolean,
      }
    );
    const viewDate = computed(() => {
      return toValue(travel) ? dayjs(toValue(travel)).toDate() : new Date();
    });



    /******************* 邮轮产品列表 *******************/
    const {
      state: listData,
      execute: fetchList,
      pageIndex,
      sortType,
      sortName,
      onPageChange,
    } = useCruiseCalendarCruiseList(() => ({
      route: toValue(cruiseRouteSecondary),
      cruise_route_first: toValue(cruiseRouteFirst),
      city: toValue(city),
      travel: toValue(date),
    }));

    const productTitle = computed(() => {
      const cityOption = cities.value.find(
        (item) => item.value === toValue(city)
      );
      return [
        dayjs(toValue(date)).format("MM月DD日"),
        cityOption ? `${cityOption.label}出发` : ``,
        "的产品",
      ].join("");
    });
    useFetch(async () => {
      await fetchFilter();
      await fetchDateList();
    })
    onBeforeMount(async () => {
      await fetchList();
    });
    // TODO: 切换筛选器，默认会触发 travel 和 date 变化 以后待结局
    watchDebounced(travel, async (newValue, oldValue) => {
      oldValue && await fetchDateList(0);
    }, {
      debounce: 100
    })

    // 页面变化重置 产品列表
    watchDebounced([
      date,
      pageIndex,
    ], async ([newDate], [oldDate]) => {
      console.log('date, pageIndex', newDate, oldDate)
      oldDate && await fetchList(0);
    }, {
      debounce: 100
    })


    return {
      breadcrumbs,

      filterData,
      months,
      cities,
      routes,
      cruiseRouteFirst,
      cruiseRouteSecondary,
      city,
      travel,
      date,

      // searchData,
      pageIndex,
      productTitle,
      checkedFirstRoute,

      // getFirstQuery,
      viewDate,
      dateData,
      getDateStockData,
      onPickDate,

      sortType,
      sortName,
      listData,

      onPageChange,
    };
  },
});
